<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<div class="container">
  <div style="vertical-align: middle; padding-bottom: 10px">
    <h1>Completati</h1>
  </div>
  <mat-card class="mat-elevation-z10">
    <ng-container *ngIf="questionnaires && questionnaires.length > 0; else notFound">
      <mat-list>
        <mat-list-item *ngFor="let q of questionnaires" style="cursor: pointer" (click)="goToPage(q)">
          <mat-icon mat-list-icon>folder</mat-icon>
          <div mat-line>
            {{q}}
          </div>
          <div mat-line>
            {{length(q)}} presenti
          </div>
        </mat-list-item>
      </mat-list>
    </ng-container>
    <ng-template #notFound>
      <div style="margin: auto">
        <h3 style="text-align: center;">Nessun questionario completato. Torna indietro.</h3>
      </div>
    </ng-template>
    <mat-card-content fxLayout="column">

    </mat-card-content>
  </mat-card>
</div>



